import React, { useState, Component } from 'react';
import { ArrowLeft, Mail, Clock, Send } from 'lucide-react';
import { Footer } from '../components/Footer';
import { CTAButton } from '../components/ui/CTAButton';
export function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Open mailto link with form data
    const subject = `Contacto desde web: ${name}`;
    const body = `Nombre: ${name}\nEmail: ${email}\n\nMensaje:\n${message}`;
    window.location.href = `mailto:amorconprincipios.info@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900 flex flex-col" data-id="element-352">
      {/* Header */}
      <header className="border-b border-gray-100 py-4 px-4 sticky top-0 bg-white/90 backdrop-blur-sm z-10" data-id="element-353">
        <div className="max-w-3xl mx-auto flex items-center justify-between" data-id="element-354">
          <a href="#" className="flex items-center gap-2 text-sm text-gray-500 hover:text-rose-600 transition-colors" data-id="element-355">
            <ArrowLeft className="h-4 w-4" data-id="element-356" />
            Volver al inicio
          </a>
          <span className="font-bold text-gray-900" data-id="element-357">
            Di Esto, <span className="text-rose-600" data-id="element-358">No Aquello™</span>
          </span>
        </div>
      </header>

      <main className="flex-grow px-4 py-12 md:py-20" data-id="element-359">
        <div className="max-w-2xl mx-auto" data-id="element-360">
          <div className="text-center mb-12" data-id="element-361">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-362">
              Contáctanos
            </h1>
            <p className="text-gray-600 text-lg" data-id="element-363">
              ¿Tienes alguna pregunta sobre el ebook o tu compra? Estamos aquí
              para ayudarte.
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2 mb-12" data-id="element-364">
            {/* Contact Info Card */}
            <div className="bg-rose-50 rounded-2xl p-6 border border-rose-100 flex flex-col justify-center items-center text-center" data-id="element-365">
              <div className="bg-white p-3 rounded-full shadow-sm mb-4" data-id="element-366">
                <Mail className="h-6 w-6 text-rose-600" data-id="element-367" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-368">
                Correo Electrónico
              </h3>
              <a href="mailto:amorconprincipios.info@gmail.com" className="text-rose-600 font-medium hover:underline break-all" data-id="element-369">
                amorconprincipios.info@gmail.com
              </a>
              <p className="text-sm text-gray-500 mt-4" data-id="element-370">
                Escríbenos directamente para cualquier consulta.
              </p>
            </div>

            {/* Response Time Card */}
            <div className="bg-blue-50 rounded-2xl p-6 border border-blue-100 flex flex-col justify-center items-center text-center" data-id="element-371">
              <div className="bg-white p-3 rounded-full shadow-sm mb-4" data-id="element-372">
                <Clock className="h-6 w-6 text-blue-600" data-id="element-373" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-374">
                Nuestro Compromiso
              </h3>
              <p className="text-blue-800 font-medium" data-id="element-375">
                Respondemos lo antes posible
              </p>
              <p className="text-sm text-gray-500 mt-4" data-id="element-376">
                Leemos cada mensaje y te responderemos a la brevedad.
              </p>
            </div>
          </div>

          {/* Simple Contact Form */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-8" data-id="element-377">
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-378">
              Envíanos un mensaje
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-379">
              <div data-id="element-380">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-381">
                  Nombre
                </label>
                <input type="text" id="name" required value={name} onChange={e => setName(e.target.value)} className="w-full rounded-lg border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 py-2.5" placeholder="Tu nombre" data-id="element-382" />
              </div>
              <div data-id="element-383">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-384">
                  Correo Electrónico
                </label>
                <input type="email" id="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full rounded-lg border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 py-2.5" placeholder="tucorreo@ejemplo.com" data-id="element-385" />
              </div>
              <div data-id="element-386">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-387">
                  Mensaje
                </label>
                <textarea id="message" required rows={4} value={message} onChange={e => setMessage(e.target.value)} className="w-full rounded-lg border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 py-2.5" placeholder="¿En qué podemos ayudarte?" data-id="element-388"></textarea>
              </div>
              <CTAButton fullWidth className="flex items-center justify-center gap-2" data-id="element-389">
                <Send className="h-4 w-4" data-id="element-390" /> Enviar Mensaje
              </CTAButton>
              <p className="text-xs text-center text-gray-400 mt-4" data-id="element-391">
                Al enviar este formulario, se abrirá tu cliente de correo
                predeterminado.
              </p>
            </form>
          </div>
        </div>
      </main>

      <Footer data-id="element-392" />
    </div>;
}